import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import CTASection from './components/CTASection';
import ArticlesSection from './components/ArticlesSection';
import TrustSection from './components/TrustSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  'name': 'KakobuyFinds - Kakobuy Spreadsheet Polska',
  'url': import.meta.env.VITE_SITE_URL,
  'description': 'Odkryj najlepszy Kakobuy Spreadsheet. Znajdź popularne produkty, listy zakupowe, porównania oraz przewodniki dotyczące Kakobuy, CSSBuy, Superbuy i Oopbuy. Kompletne arkusze produktów i aktualne listy finds.',
  'inLanguage': 'pl-PL',
  'publisher': {
    '@type': 'Organization',
    'name': 'KakobuyFinds',
  },
};

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <Navbar />
      <HeroSection />
      <CategoryGrid />
      <CTASection />
      <ArticlesSection />
      <TrustSection />
      <FAQSection />
      <Footer />
    </main>
  );
}